import { AssetByAssetCodeQuery, RegistryCode } from "@/app/types/generated/graphql";

export const demoAssets: AssetByAssetCodeQuery = {
  assetByAssetCode: {
    attributes: [
      {
        id: "71d6b8ee-b411-4d34-ab90-5644e9ae02a0",
        name: "certificateType",
        registryCode: RegistryCode.Mrets,
        values: [
          {
            code: "R",
            displayName: "Regular",
            key: null,
            __typename: "AttributeValue",
          },
        ],
        mandatory: false,
        __typename: "AssetAttribute",
      },
      {
        id: "e4086faf-b4b0-404e-92c7-187f14e26a9d",
        name: "location",
        registryCode: RegistryCode.Mrets,
        values: [
          {
            code: "AL",
            displayName: "Alabama",
            key: "USA",
            __typename: "AttributeValue",
          },
          {
            code: "ME",
            displayName: "Maine",
            key: "USA",
            __typename: "AttributeValue",
          },
          {
            code: "GA",
            displayName: "Georgia",
            key: "USA",
            __typename: "AttributeValue",
          },
          {
            code: "NU",
            displayName: "Nunavut",
            key: "Canada",
            __typename: "AttributeValue",
          },
          {
            code: "AP",
            displayName: "Armed Forces Pacific",
            key: "USA",
            __typename: "AttributeValue",
          },
          {
            code: "VI",
            displayName: "US Virgin Islands",
            key: "USA",
            __typename: "AttributeValue",
          },
          {
            code: "AK",
            displayName: "Alaska",
            key: "USA",
            __typename: "AttributeValue",
          },
          {
            code: "TX",
            displayName: "Texas",
            key: "USA",
            __typename: "AttributeValue",
          },
          {
            code: "UT",
            displayName: "Utah",
            key: "USA",
            __typename: "AttributeValue",
          },
          {
            code: "MO",
            displayName: "Missouri",
            key: "USA",
            __typename: "AttributeValue",
          },
          {
            code: "OH",
            displayName: "Ohio",
            key: "USA",
            __typename: "AttributeValue",
          },
          {
            code: "AR",
            displayName: "Arkansas",
            key: "USA",
            __typename: "AttributeValue",
          },
          {
            code: "GU",
            displayName: "Guam",
            key: "USA",
            __typename: "AttributeValue",
          },
          {
            code: "MN",
            displayName: "Minnesota",
            key: "USA",
            __typename: "AttributeValue",
          },
          {
            code: "MI",
            displayName: "Michigan",
            key: "USA",
            __typename: "AttributeValue",
          },
          {
            code: "ON",
            displayName: "Ontario",
            key: "Canada",
            __typename: "AttributeValue",
          },
          {
            code: "TN",
            displayName: "Tennessee",
            key: "USA",
            __typename: "AttributeValue",
          },
          {
            code: "NB",
            displayName: "New Brunswick",
            key: "Canada",
            __typename: "AttributeValue",
          },
          {
            code: "MT",
            displayName: "Montana",
            key: "USA",
            __typename: "AttributeValue",
          },
          {
            code: "QC",
            displayName: "Quebec",
            key: "Canada",
            __typename: "AttributeValue",
          },
          {
            code: "DE",
            displayName: "Delaware",
            key: "USA",
            __typename: "AttributeValue",
          },
          {
            code: "VA",
            displayName: "Virginia",
            key: "USA",
            __typename: "AttributeValue",
          },
          {
            code: "IA",
            displayName: "Iowa",
            key: "USA",
            __typename: "AttributeValue",
          },
          {
            code: "SC",
            displayName: "South Carolina",
            key: "USA",
            __typename: "AttributeValue",
          },
          {
            code: "SD",
            displayName: "South Dakota",
            key: "USA",
            __typename: "AttributeValue",
          },
          {
            code: "WV",
            displayName: "West Virginia",
            key: "USA",
            __typename: "AttributeValue",
          },
          {
            code: "CO",
            displayName: "Colorado",
            key: "USA",
            __typename: "AttributeValue",
          },
          {
            code: "OK",
            displayName: "Oklahoma",
            key: "USA",
            __typename: "AttributeValue",
          },
          {
            code: "ID",
            displayName: "Idaho",
            key: "USA",
            __typename: "AttributeValue",
          },
          {
            code: "PR",
            displayName: "Puerto Rico",
            key: "USA",
            __typename: "AttributeValue",
          },
          {
            code: "CA",
            displayName: "California",
            key: "USA",
            __typename: "AttributeValue",
          },
          {
            code: "IL",
            displayName: "Illinois",
            key: "USA",
            __typename: "AttributeValue",
          },
          {
            code: "MH",
            displayName: "Marshall Islands",
            key: "USA",
            __typename: "AttributeValue",
          },
          {
            code: "WA",
            displayName: "Washington",
            key: "USA",
            __typename: "AttributeValue",
          },
          {
            code: "IN",
            displayName: "Indiana",
            key: "USA",
            __typename: "AttributeValue",
          },
          {
            code: "KS",
            displayName: "Kansas",
            key: "USA",
            __typename: "AttributeValue",
          },
          {
            code: "SK",
            displayName: "Saskatchewan",
            key: "Canada",
            __typename: "AttributeValue",
          },
          {
            code: "CT",
            displayName: "Connecticut",
            key: "USA",
            __typename: "AttributeValue",
          },
          {
            code: "PA",
            displayName: "Pennsylvania",
            key: "USA",
            __typename: "AttributeValue",
          },
          {
            code: "WY",
            displayName: "Wyoming",
            key: "USA",
            __typename: "AttributeValue",
          },
          {
            code: "UM",
            displayName: "United States Minor Outlying Islands",
            key: "USA",
            __typename: "AttributeValue",
          },
          {
            code: "NM",
            displayName: "New Mexico",
            key: "USA",
            __typename: "AttributeValue",
          },
          {
            code: "NC",
            displayName: "North Carolina",
            key: "USA",
            __typename: "AttributeValue",
          },
          {
            code: "AS",
            displayName: "American Samoa",
            key: "USA",
            __typename: "AttributeValue",
          },
          {
            code: "KY",
            displayName: "Kentucky",
            key: "USA",
            __typename: "AttributeValue",
          },
          {
            code: "NP",
            displayName: "Northern Mariana Islands",
            key: "USA",
            __typename: "AttributeValue",
          },
          {
            code: "NF",
            displayName: "Newfoundland and Labrador",
            key: "Canada",
            __typename: "AttributeValue",
          },
          {
            code: "HI",
            displayName: "Hawaii",
            key: "USA",
            __typename: "AttributeValue",
          },
          {
            code: "RI",
            displayName: "Rhode Island",
            key: "USA",
            __typename: "AttributeValue",
          },
          {
            code: "AZ",
            displayName: "Arizona",
            key: "USA",
            __typename: "AttributeValue",
          },
          {
            code: "OR",
            displayName: "Oregon",
            key: "USA",
            __typename: "AttributeValue",
          },
          {
            code: "AA",
            displayName: "Armed Forces Americas",
            key: "USA",
            __typename: "AttributeValue",
          },
          {
            code: "BC",
            displayName: "British Columbia",
            key: "Canada",
            __typename: "AttributeValue",
          },
          {
            code: "PE",
            displayName: "Prince Edward Island",
            key: "Canada",
            __typename: "AttributeValue",
          },
          {
            code: "VT",
            displayName: "Vermont",
            key: "USA",
            __typename: "AttributeValue",
          },
          {
            code: "LA",
            displayName: "Louisiana",
            key: "USA",
            __typename: "AttributeValue",
          },
          {
            code: "MS",
            displayName: "Mississippi",
            key: "USA",
            __typename: "AttributeValue",
          },
          {
            code: "MD",
            displayName: "Maryland",
            key: "USA",
            __typename: "AttributeValue",
          },
          {
            code: "NE",
            displayName: "Nebraska",
            key: "USA",
            __typename: "AttributeValue",
          },
          {
            code: "ND",
            displayName: "North Dakota",
            key: "USA",
            __typename: "AttributeValue",
          },
          {
            code: "MB",
            displayName: "Manitoba",
            key: "Canada",
            __typename: "AttributeValue",
          },
          {
            code: "NT",
            displayName: "Northwest Territories",
            key: "Canada",
            __typename: "AttributeValue",
          },
          {
            code: "YT",
            displayName: "Yukon",
            key: "Canada",
            __typename: "AttributeValue",
          },
          {
            code: "NS",
            displayName: "Nova Scotia",
            key: "Canada",
            __typename: "AttributeValue",
          },
          {
            code: "WI",
            displayName: "Wisconsin",
            key: "USA",
            __typename: "AttributeValue",
          },
          {
            code: "NV",
            displayName: "Nevada",
            key: "USA",
            __typename: "AttributeValue",
          },
          {
            code: "AE",
            displayName: "Armed Forces Europe",
            key: "USA",
            __typename: "AttributeValue",
          },
          {
            code: "FL",
            displayName: "Florida",
            key: "USA",
            __typename: "AttributeValue",
          },
          {
            code: "NH",
            displayName: "New Hampshire",
            key: "USA",
            __typename: "AttributeValue",
          },
          {
            code: "NY",
            displayName: "New York",
            key: "USA",
            __typename: "AttributeValue",
          },
          {
            code: "DC",
            displayName: "District of Columbia",
            key: "USA",
            __typename: "AttributeValue",
          },
          {
            code: "MA",
            displayName: "Massachusetts",
            key: "USA",
            __typename: "AttributeValue",
          },
          {
            code: "NJ",
            displayName: "New Jersey",
            key: "USA",
            __typename: "AttributeValue",
          },
          {
            code: "AB",
            displayName: "Alberta",
            key: "Canada",
            __typename: "AttributeValue",
          },
        ],
        mandatory: false,
        __typename: "AssetAttribute",
      },
      {
        id: "32e509fd-dd2e-480f-819c-2cac81b162bf",
        name: "eligibility",
        registryCode: RegistryCode.Mrets,
        values: [
          {
            code: "mb",
            displayName: "Manitoba",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "sd",
            displayName: "South Dakota",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "oh",
            displayName: "Ohio",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "ia",
            displayName: "Iowa",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "mn",
            displayName: "Minnesota",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "ia_aep",
            displayName: "Iowa AEP",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "mn_ses_small_solar",
            displayName: "Minnesota SES Small Solar",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "nd",
            displayName: "North Dakota",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "ia_voluntary_green",
            displayName: "Iowa Voluntary Green",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "wi_non_bankable",
            displayName: "Wisconsin Non Bankable",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "mt",
            displayName: "Montana",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "mn_habitat",
            displayName: "Minnesota Habitat",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "il_utility",
            displayName: "Illinois Utility",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "wi_bankable",
            displayName: "Wisconsin Bankable",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "il_ares",
            displayName: " Illinois ARES",
            key: null,
            __typename: "AttributeValue",
          },
        ],
        mandatory: false,
        __typename: "AssetAttribute",
      },
      {
        id: "ff5b1d98-02dd-47e3-b0c5-ecf1dac1a294",
        name: "fuelSource",
        registryCode: RegistryCode.Mrets,
        values: [
          {
            code: "AB1",
            displayName: "Biomass - Agricultural Crop (closed loop)",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "GE1",
            displayName: "Geothermal Energy",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "HY2",
            displayName: "Hydro (WI Eligible)",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "PA1",
            displayName: "Biomass - Paper-derived",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "ARS",
            displayName: "Air Source",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "HYD",
            displayName: "Hydrogen",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "BHV",
            displayName: "Biomass - Herbaceous Vegetative Matter or Residue",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "WD2",
            displayName: "Wind (WI Eligible)",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "BA2",
            displayName: "Biomass - Animal Waste - Poultry",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "CHE",
            displayName: "Compost Heat Exchange System",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "AB2",
            displayName: "Biomass - Agricultural Crop (open loop)",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "BIG",
            displayName: "Biogas",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "WDU",
            displayName: "Biomass - Wood - Utility Poles",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "GWS",
            displayName: "Ground And Water Source Head Pump",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "WDL",
            displayName: "Biomass - Wood - Wood Waste Liquids",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "RNG",
            displayName: "Renewable Natural Gas",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "RDF",
            displayName: "Biomass - Refuse-Derived Fuel",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "OC1",
            displayName: "Tidal or Wave",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "BTW",
            displayName: "Biomass - Treated Organic Waste Biomass",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "MS1",
            displayName: "Municipal solid Waste",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "BSW",
            displayName: "Biomass - sustainably managed woody biomass",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "BGR",
            displayName: "Biomass - Incineration of Garbage",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "WHR",
            displayName: "Waste Heat Recovery",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "BM2",
            displayName: "Biomass (WI Eligible)",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "BAW",
            displayName: "Biomass - Agricultural Waste",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "BIM",
            displayName: "Biomass",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "BA3",
            displayName: "Biomass - Animal Waste - Other",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "BBL",
            displayName: "Biomass - Liquids",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "BNV",
            displayName: "Biomass - Non vegetation waste",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "BAF",
            displayName: "Biomass - Alt fuels from plant oils or animal fats",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "BA1",
            displayName: "Biomass - Animal Waste - Swine",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "CON",
            displayName: "Conversion of Fuel from Natural Gas Pipeline",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "WDR",
            displayName: "Biomass - Wood - Railroad Ties",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "BFG",
            displayName: "Gas - Blast-Furnace Gas",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "NU1",
            displayName: "Nuclear",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "BLQ",
            displayName: "Biomass - Black Liquor",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "WDS",
            displayName: "Biomass - Wood - Wood/Wood Waste Solids",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "SOT",
            displayName: "Solar Thermal",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "RWB",
            displayName: "Biomass - Recovered Woody Biomass",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "WBS",
            displayName: "Woody Biomass System",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "BBW",
            displayName: "Biomass - Biological Waste",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "TDF",
            displayName: "Tire Derived Fuel",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "BUW",
            displayName: "Biomass - Untreated Organic Waste Biomass",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "H2O",
            displayName: "Hydroelectric Water",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "ALT",
            displayName: "Alternate Use",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "BID",
            displayName: "Biomass - Incineration of Construction Debris",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "WND",
            displayName: "Wind",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "SLW",
            displayName: "Biomass - Sludge Waste",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "SO1",
            displayName: "Solar",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "FC1",
            displayName: "Fuel Cells",
            key: null,
            __typename: "AttributeValue",
          },
        ],
        mandatory: false,
        __typename: "AssetAttribute",
      },
      {
        id: "4f743c0c-0c08-435a-8bc7-cecec61d75a7",
        name: "certification",
        registryCode: RegistryCode.Mrets,
        values: [
          {
            code: "CRS",
            displayName: "CRS Listed",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "ecologo",
            displayName: "Ecologo Certified",
            key: null,
            __typename: "AttributeValue",
          },
        ],
        mandatory: false,
        __typename: "AssetAttribute",
      },
      {
        id: "2742c5d1-93eb-445e-8136-d73d935344ff",
        name: "vintageHalf",
        registryCode: RegistryCode.Mrets,
        values: [
          {
            code: "BACK_HALF",
            displayName: "BH",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "FRONT_HALF",
            displayName: "FH",
            key: null,
            __typename: "AttributeValue",
          },
        ],
        mandatory: false,
        __typename: "AssetAttribute",
      },
      {
        id: "7cea3346-51e4-4582-b02d-93fe3d411119",
        name: "vintage",
        registryCode: RegistryCode.Mrets,
        values: [
          {
            code: "2017",
            displayName: "2017",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "2025",
            displayName: "2025",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "2022",
            displayName: "2022",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "2030",
            displayName: "2030",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "2015",
            displayName: "2015",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "2027",
            displayName: "2027",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "2018",
            displayName: "2018",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "2024",
            displayName: "2024",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "2021",
            displayName: "2021",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "2029",
            displayName: "2029",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "2016",
            displayName: "2016",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "2026",
            displayName: "2026",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "2019",
            displayName: "2019",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "2023",
            displayName: "2023",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "2020",
            displayName: "2020",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "2028",
            displayName: "2028",
            key: null,
            __typename: "AttributeValue",
          },
        ],
        mandatory: true,
        __typename: "AssetAttribute",
      },
      {
        id: "976e80e6-217b-4ac0-be68-d671d9b2bd2a",
        name: "project",
        registryCode: RegistryCode.Mrets,
        values: [
          {
            code: "M3848",
            displayName: "Humpback Creek",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "M22318",
            displayName: "Triple H Wind Project, LLC",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "M3595",
            displayName: "Falls Creek",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "M3592",
            displayName: "Black Bear Lake",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "M3594",
            displayName: "South Fork",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "M1073",
            displayName: "Brady Wind I - Brady Wind, LLC",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "IMP17440",
            displayName: "IMP - Route 66 Wind Power",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "M16325",
            displayName: "Balm Solar",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "M16323",
            displayName: "TIA Solar",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "M3589",
            displayName: "Goat Lake Hydroelectric Project",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "M16324",
            displayName: "Legoland Solar",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "M16354",
            displayName: "Big Bend Solar - Generator ID 1",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "M16643",
            displayName: "Wild Springs Solar, LLC",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "M3013",
            displayName: "Northern Divide Wind, LLC",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "M3596",
            displayName: "Connexus Solar Stanford 1STF",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "M18647",
            displayName: "Units 1-2",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "M3624",
            displayName: "Hydro-Canyon Saint-Joachim",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "IMP4137",
            displayName: "IMP-  East Fork - East Fork Wind Park, LLC",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "M302",
            displayName: "Laurie River 1 - Laurie River 1",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "IMP18320",
            displayName: "IMP - BARROW RANCH",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "M3590",
            displayName: "Kasidaya Creek Hydroelectric Project",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "M3847",
            displayName: "Power Creek",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "M16326",
            displayName: "Bonnie Mine Solar",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "IMP14546",
            displayName: "IMP - King Plains - King Plains Wind Park, LLC\t",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "M1074",
            displayName: "Brady Wind II - Brady Wind II, LLC",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "M3566",
            displayName: "Skagway-Dewey Lakes Hydroelectric Project",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "M4339",
            displayName: "Swan Lake",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "M4107",
            displayName: "Hiilangaay Hydroelectric Project",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "M4340",
            displayName: "Tyee Lake",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "IMP3309",
            displayName: "IMPORT: Triple H - Triple H Wind Project, LLC",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "M3853",
            displayName: "Ford County 1",
            key: null,
            __typename: "AttributeValue",
          },
        ],
        mandatory: false,
        __typename: "AssetAttribute",
      },
    ],
    displayName: "REC",
    code: "REC",
    id: "910b3752-f4b1-4713-b940-cf51dce65a9d",
    name: "REC",
    __typename: "Asset",
  },
};

export const demoAssetsERCOT: AssetByAssetCodeQuery = {
  assetByAssetCode: {
    id: "910b3752-f4b1-4713-b940-cf51dce65a9d",
    code: "REC",
    name: "REC",
    displayName: "REC",
    attributes: [
      {
        name: "location",
        registryCode: RegistryCode.Ercot,
        values: [
          {
            code: "TX",
            displayName: "Texas",
            key: "USA",
            __typename: "AttributeValue",
          },
        ],
        id: "2dfb8263-eb14-43e3-9e48-903e06dae3a6",
        mandatory: false,
        __typename: "AssetAttribute",
      },
      {
        id: "727dfdba-4d2c-4432-ba1d-9fb5dea8c609",
        name: "vintageHalf",
        registryCode: RegistryCode.Ercot,
        values: [
          {
            code: "Q1",
            displayName: "Q1",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "Q4",
            displayName: "Q4",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "Q3",
            displayName: "Q3",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "Q2",
            displayName: "Q2",
            key: null,
            __typename: "AttributeValue",
          },
        ],
        mandatory: false,
        __typename: "AssetAttribute",
      },
      {
        id: "ed8c753f-9b69-4246-aba3-d307e24468d9",
        name: "certification",
        registryCode: RegistryCode.Ercot,
        values: [
          {
            code: "CRS",
            displayName: "CRS Listed",
            key: null,
            __typename: "AttributeValue",
          },
        ],
        mandatory: false,
        __typename: "AssetAttribute",
      },
      {
        id: "95763b4c-564a-4394-94f9-665edb81a935",
        name: "certificateType",
        registryCode: RegistryCode.Ercot,
        values: [
          {
            code: "CP",
            displayName: "Compliance Premium",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "R",
            displayName: "Regular",
            key: null,
            __typename: "AttributeValue",
          },
        ],
        mandatory: false,
        __typename: "AssetAttribute",
      },
      {
        id: "de309418-2c1f-4b65-b4fa-016a34ac2ec5",
        name: "fuelSource",
        registryCode: RegistryCode.Ercot,
        values: [
          {
            code: "BM",
            displayName: "Biomass",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "TI",
            displayName: "Tidal",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "WND",
            displayName: "Wind",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "GT",
            displayName: "GeoThermal",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "H20",
            displayName: "Hydro",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "SO",
            displayName: "Solar",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "OTHER",
            displayName: "Other",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "LFG",
            displayName: "Landfill gas",
            key: null,
            __typename: "AttributeValue",
          },
        ],
        mandatory: false,
        __typename: "AssetAttribute",
      },
      {
        id: "0448698f-2510-4ba5-ad6c-ba58149741fd",
        name: "vintage",
        registryCode: RegistryCode.Ercot,
        values: [
          {
            code: "2017",
            displayName: "2017",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "2025",
            displayName: "2025",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "2022",
            displayName: "2022",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "2030",
            displayName: "2030",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "2015",
            displayName: "2015",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "2027",
            displayName: "2027",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "2018",
            displayName: "2018",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "2024",
            displayName: "2024",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "2021",
            displayName: "2021",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "2029",
            displayName: "2029",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "2016",
            displayName: "2016",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "2026",
            displayName: "2026",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "2019",
            displayName: "2019",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "2023",
            displayName: "2023",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "2020",
            displayName: "2020",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "2028",
            displayName: "2028",
            key: null,
            __typename: "AttributeValue",
          },
        ],
        mandatory: true,
        __typename: "AssetAttribute",
      },
      {
        id: "29b130ec-5fca-45fe-bdff-b7b314cb90e2",
        name: "project",
        registryCode: RegistryCode.Ercot,
        values: [
          {
            code: "1403",
            displayName: "1403",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "2739",
            displayName: "2739",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "213",
            displayName: "213",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "2752",
            displayName: "2752",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "2740",
            displayName: "2740",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "2642",
            displayName: "2642",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "2620",
            displayName: "2620",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "1436",
            displayName: "1436",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "1267",
            displayName: "1267",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "2751",
            displayName: "2751",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "1326",
            displayName: "1326",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "1375",
            displayName: "1375",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "2741",
            displayName: "2741",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "2744",
            displayName: "2744",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "1426",
            displayName: "1426",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "2742",
            displayName: "2742",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "214",
            displayName: "214",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "2737",
            displayName: "2737",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "52",
            displayName: "52",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "2743",
            displayName: "2743",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "1486",
            displayName: "1486",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "1381",
            displayName: "1381",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "2738",
            displayName: "2738",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "1269",
            displayName: "1269",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "1409",
            displayName: "1409",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "1480",
            displayName: "1480",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "151",
            displayName: "151",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "2750",
            displayName: "2750",
            key: null,
            __typename: "AttributeValue",
          },
        ],
        mandatory: false,
        __typename: "AssetAttribute",
      },
    ],
    __typename: "Asset",
  },
};

export const demoAssetsForAnyRegistry: AssetByAssetCodeQuery = {
  assetByAssetCode: {
    id: "910b3752-f4b1-4713-b940-cf51dce65a9d",
    code: "REC",
    name: "REC",
    displayName: "REC",
    attributes: [
      ...(demoAssets.assetByAssetCode?.attributes ?? []),
      ...(demoAssetsERCOT.assetByAssetCode?.attributes ?? []),
      {
        id: "3a813838-7e5b-4c7a-825d-0bb030f73a04",
        name: "vintage",
        registryCode: null,
        values:
          demoAssets.assetByAssetCode?.attributes?.find((attribute) => attribute.name === "vintage")?.values ?? [],
        mandatory: true,
        __typename: "AssetAttribute",
      },
      {
        id: "4af51c58-6e66-4710-b2e9-d6afc7964452",
        name: "location",
        registryCode: null,
        values:
          demoAssets.assetByAssetCode?.attributes?.find((attribute) => attribute.name === "location")?.values ?? [],
        mandatory: false,
        __typename: "AssetAttribute",
      },
      {
        id: "b9898524-772b-40de-bfe1-4bcc107d586c",
        name: "eligibility",
        registryCode: null,
        values:
          demoAssets.assetByAssetCode?.attributes?.find((attribute) => attribute.name === "eligibility")?.values ?? [],
        mandatory: false,
        __typename: "AssetAttribute",
      },
      {
        id: "bdef3f21-09b6-4481-a7ec-b72adde61cab",
        name: "certificateType",
        registryCode: null,
        values:
          demoAssetsERCOT.assetByAssetCode?.attributes?.find((attribute) => attribute.name === "certificateType")
            ?.values ?? [],
        mandatory: false,
        __typename: "AssetAttribute",
      },

      {
        id: "6c13cad5-750c-422a-855d-2626337d3862",
        name: "certification",
        registryCode: null,
        values:
          demoAssets.assetByAssetCode?.attributes?.find((attribute) => attribute.name === "certification")?.values ??
          [],
        mandatory: false,
        __typename: "AssetAttribute",
      },
      {
        id: "c4591db6-c82c-48ac-9c20-8f5014f9422e",
        name: "fuelSource",
        registryCode: null,
        values: [
          {
            code: "BA1",
            displayName: "Biomass - Animal Waste - Swine",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "BUW",
            displayName: "Biomass - Untreated Organic Waste Biomass",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "AB2",
            displayName: "Biomass - Agricultural Crop (open loop)",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "WDL",
            displayName: "Biomass - Wood - Wood Waste Liquids",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "BHV",
            displayName: "Biomass - Herbaceous Vegetative Matter or Residue",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "ALT",
            displayName: "Alternate Use",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "BSW",
            displayName: "Biomass - sustainably managed woody biomass",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "BBW",
            displayName: "Biomass - Biological Waste",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "BGR",
            displayName: "Biomass - Incineration of Garbage",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "ARS",
            displayName: "Air Source",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "RNG",
            displayName: "Renewable Natural Gas",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "BIG",
            displayName: "Biogas",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "FC1",
            displayName: "Fuel Cells",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "WND",
            displayName: "Wind",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "AB1",
            displayName: "Biomass - Agricultural Crop (closed loop)",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "BID",
            displayName: "Biomass - Incineration of Construction Debris",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "BBL",
            displayName: "Biomass - Liquids",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "SLW",
            displayName: "Biomass - Sludge Waste",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "OC1",
            displayName: "Tidal or Wave",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "WDR",
            displayName: "Biomass - Wood - Railroad Ties",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "H2O",
            displayName: "Hydroelectric Water",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "BNV",
            displayName: "Biomass - Non vegetation waste",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "BTW",
            displayName: "Biomass - Treated Organic Waste Biomass",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "MS1",
            displayName: "Municipal solid Waste",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "BFG",
            displayName: "Gas - Blast-Furnace Gas",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "RWB",
            displayName: "Biomass - Recovered Woody Biomass",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "BA2",
            displayName: "Biomass - Animal Waste - Poultry",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "WHR",
            displayName: "Waste Heat Recovery",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "WDU",
            displayName: "Biomass - Wood - Utility Poles",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "BM2",
            displayName: "Biomass (WI Eligible)",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "HYD",
            displayName: "Hydrogen",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "BIM",
            displayName: "Biomass",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "HY2",
            displayName: "Hydro (WI Eligible)",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "CON",
            displayName: "Conversion of Fuel from Natural Gas Pipeline",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "WD2",
            displayName: "Wind (WI Eligible)",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "RDF",
            displayName: "Biomass - Refuse-Derived Fuel",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "WBS",
            displayName: "Woody Biomass System",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "BAW",
            displayName: "Biomass - Agricultural Waste",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "WDS",
            displayName: "Biomass - Wood - Wood/Wood Waste Solids",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "GWS",
            displayName: "Ground And Water Source Head Pump",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "SO1",
            displayName: "Solar",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "OTHER",
            displayName: "Other",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "BAF",
            displayName: "Biomass - Alt fuels from plant oils or animal fats",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "LFG",
            displayName: "Landfill gas",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "TDF",
            displayName: "Tire Derived Fuel",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "GE1",
            displayName: "Geothermal Energy",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "BA3",
            displayName: "Biomass - Animal Waste - Other",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "NU1",
            displayName: "Nuclear",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "BLQ",
            displayName: "Biomass - Black Liquor",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "SOT",
            displayName: "Solar Thermal",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "CHE",
            displayName: "Compost Heat Exchange System",
            key: null,
            __typename: "AttributeValue",
          },
          {
            code: "PA1",
            displayName: "Biomass - Paper-derived",
            key: null,
            __typename: "AttributeValue",
          },
        ],
        mandatory: false,
        __typename: "AssetAttribute",
      },
      {
        id: "bbb6057d-2307-489b-b638-37af9d7f07c3",
        name: "vintageHalf",
        registryCode: null,
        values:
          demoAssets.assetByAssetCode?.attributes?.find((attribute) => attribute.name === "vintageHalf")?.values ?? [],
        mandatory: false,
        __typename: "AssetAttribute",
      },
    ],
    __typename: "Asset",
  },
};
